import { createReducer } from '@/redux/root';
import {
  nameSpace,
  requestMigrationJobsAsync,
  getPatAsync,
  updatePatAsync,
  removePatAsync,
} from './actions';
import { logoutAction } from '@/redux/auth';

const initialState = {
  migrationJobs: {
    data: [],
    meta: null,
  },
  pat: null,
};

export const aspynMigratorReducer = createReducer(nameSpace, initialState, {
  [requestMigrationJobsAsync.success]: ({ state, action: { payload } }) => {
    state.migrationJobs = {
      data: payload.data || [],
      meta: payload.meta || null,
    };
  },

  [requestMigrationJobsAsync.failure]: ({ state }) => {
    state.migrationJobs = {
      data: [],
      meta: null,
    };
  },

  [getPatAsync.success]: ({ state, action: { payload } }) => {
    state.pat = payload.pat ? {
      token: payload.pat,
      expiresAt: payload.expires_at,
    } : initialState.pat;
  },

  [getPatAsync.failure]: ({ state }) => {
    state.pat = initialState.pat;
  },

  [updatePatAsync.success]: ({ state, action: { payload } }) => {
    state.pat = payload.pat ? {
      token: payload.pat,
      expiresAt: payload.expires_at,
    } : initialState.pat;
  },

  [removePatAsync.success]: ({ state }) => {
    state.pat = initialState.pat;
  },

  [logoutAction]: ({ state }) => {
    state.migrationJobs = {
      data: [],
      meta: null,
    };
    state.pat = null;
  },
});
